import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { Bell, ChevronRight } from 'lucide-react';

const ALERTAS = [
  {
    key: 'vencimentos_atrasados',
    label: 'Vencimentos Atrasados',
    link: '/comissoes',
    cores: { bg: 'bg-red-50', border: 'border-red-200', num: 'text-red-600', sub: 'text-red-400', btn: 'text-red-500' },
  },
  {
    key: 'pedidos_atrasados',
    label: 'Pedidos Atrasados',
    link: '/pedidos',
    cores: { bg: 'bg-red-50', border: 'border-red-200', num: 'text-red-600', sub: 'text-red-400', btn: 'text-red-500' },
  },
  {
    key: 'clientes_em_risco',
    label: 'Clientes em Risco',
    link: '/inteligencia-comercial',
    cores: { bg: 'bg-orange-50', border: 'border-orange-200', num: 'text-orange-500', sub: 'text-orange-400', btn: 'text-orange-500' },
  },
  {
    key: 'clientes_sem_compra',
    label: 'Sem Compra (30d)',
    link: '/inteligencia-comercial',
    cores: { bg: 'bg-amber-50', border: 'border-amber-200', num: 'text-amber-600', sub: 'text-amber-400', btn: 'text-amber-600' },
  },
  {
    key: 'orcamentos_vencidos',
    label: 'Orçamentos Vencidos',
    link: '/orcamentos',
    cores: { bg: 'bg-violet-50', border: 'border-violet-200', num: 'text-violet-600', sub: 'text-violet-400', btn: 'text-violet-500' },
  },
];

const AlertasCard = () => {
  const navigate = useNavigate();
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    api.get('/dashboard/alertas')
      .then(res => setDados(res.data))
      .catch(() => setErro(true))
      .finally(() => setLoading(false));
  }, []);

  const totalAlertas = dados ? ALERTAS.reduce((acc, a) => acc + (dados[a.key] || 0), 0) : 0;
  const semAlertas = !loading && !erro && dados && totalAlertas === 0;
  const comAlertas = !loading && !erro && dados && totalAlertas > 0;

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center gap-3">
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${comAlertas ? 'bg-red-50' : 'bg-slate-50'}`}>
          <Bell size={16} className={comAlertas ? 'text-red-500' : 'text-slate-400'} />
        </div>
        <div>
          <p className="text-sm font-black text-slate-800">Central de Alertas</p>
          <p className="text-xs text-slate-400">
            {loading && 'Carregando...'}
            {semAlertas && 'Nenhum alerta ativo'}
            {comAlertas && `${totalAlertas} ${totalAlertas === 1 ? 'item precisa' : 'itens precisam'} de atenção`}
            {erro && 'Erro ao carregar'}
          </p>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-6">
          <div className="w-6 h-6 border-4 border-slate-200 border-t-[#0A3D73] rounded-full animate-spin" />
        </div>
      ) : erro ? (
        <div className="flex items-center justify-center py-6">
          <p className="text-sm text-red-500 font-semibold">Erro ao carregar alertas</p>
        </div>
      ) : semAlertas ? (
        <div className="flex flex-col items-center justify-center py-6 gap-1">
          <p className="text-sm font-black text-green-600">Tudo em ordem</p>
          <p className="text-xs text-slate-400">Nenhum alerta ativo no momento</p>
        </div>
      ) : (
        <div className="px-5 py-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {ALERTAS.map((a) => {
              const val = dados[a.key] || 0;
              const ativo = val > 0;
              return (
                <div
                  key={a.key}
                  className={`rounded-lg border py-3 px-2 text-center flex flex-col items-center gap-1 ${
                    ativo ? `${a.cores.bg} ${a.cores.border}` : 'bg-slate-50 border-slate-100'
                  }`}
                >
                  <p className={`text-2xl font-black leading-none ${ativo ? a.cores.num : 'text-slate-300'}`}>
                    {val}
                  </p>
                  <p className={`text-[10px] font-black uppercase tracking-wide leading-tight ${ativo ? a.cores.sub : 'text-slate-300'}`}>
                    {a.label}
                  </p>
                  {ativo && (
                    <button
                      onClick={() => navigate(a.link)}
                      className={`flex items-center gap-0.5 text-[10px] font-black mt-0.5 hover:opacity-70 transition-opacity ${a.cores.btn}`}
                    >
                      Ver detalhes <ChevronRight size={9} />
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default AlertasCard;
